import React, { useEffect, useState, useContext } from "react";
import {
  Box,
  Grid,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
  Chip,
  Typography,
  Paper,
  Checkbox,
  Select,
  MenuItem,
  TextField,
  Menu,
  IconButton
} from "@mui/material";
import './message.css'
import { MailIcon, SendIconBlack, SendIconWhite, InboxIcon, DeleteIcon, ManageGroups, FilterIcon, NoMailIcon, ReplyMail, DeleteMail, AttachIcon,SelectIcon, SendIconColored, SendIcon, DeleteIconColored } from "../../components/Layout/Svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ApiService from "../../functions/apiService";
import { toast } from "react-toastify";
import moment from "moment";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ButtonDatePickerNew from "../../components/DatePickers/ButtonDatePickerNew";
import AuthContext from "../../context/AuthContext";
import CircularProgress from "@mui/material/CircularProgress";
import { ConnectingAirportsOutlined } from "@mui/icons-material";
import StarIcon from "@mui/icons-material/Star";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export const Message = () => {

  const [selectedId, setSelectedId] = useState(1);
  const { permission, pages } = useContext(AuthContext);
  const [mailbox, setMailbox] = useState("inbox");
  const [loading, setLoading] = useState(false)
  const [headers, setHeaders] = useState();
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [checkedIds, setCheckedIds] = useState([]);
  const [showCheckbox, setShowCheckbox] = useState(false);
  const [isNewMessage, setIsNewMessage] = useState(false);
  const [sendTo, setSendTo] = useState([]);
  const [selectedHeader, setSelectedHeader] = useState('');
  const [selectedValue, setSelectedValue] = useState('');
  const [messages, setMessages] = useState([])
  const [loadingTarget, setLoadingTarget] = useState(null);
  const [isThreadCollapsed, setIsThreadCollapsed] = useState(false);
  const [collapsedMap, setCollapsedMap] = useState({});
  const [collapsedDates, setCollapsedDates] = useState({});



  const [via, setVia] = useState({
    sms: false,
    push: true,
    email: false,
  });
  const [subject, setSubject] = useState('');
  const [messageBody, setMessageBody] = useState('');
  const [filterAnchor, setFilterAnchor] = useState(null);
  const [sortAnchor, setSortAnchor] = useState(null);
  const [filterValue, setFilterValue] = useState("All");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [openCalendar, setOpenCalendar] = useState(false);
  const [statusFilter, setStatusFilter] = useState(""); 
  const [sortByDate, setSortByDate] = useState("");  
  const [isReply, setIsReply] = useState(false);

  useEffect(() => {
    setLoading(true);
    ApiService.get(`/getMessageTo?sort_by_lastname=${true}`)
      .then(({ data }) => {
        const allHeaders = Object?.keys(data?.data);

        const filteredHeaders = allHeaders?.filter(
          (item) => !["Each Member", "Custom Group"].includes(item)
        );

        setSendTo(data?.data);
        setHeaders(filteredHeaders);
        setLoading(false);
      });
  }, []);

  const fetchMessages = async (type = "inbox") => {
  setLoading(true);
  setLoadingTarget("list");

  const body = {
    status: statusFilter,
    sort_by: sortByDate,
  };

  const endpoints = {
    inbox: "/message/inbox",
    sent: "/message/sent",
    deleted: "/message/deleted-messages",
  };

  const endpoint = endpoints[type];

  const getLastMessage = (messages = []) =>
    messages[messages.length - 1];

  try {
    const res =
      type === "deleted"
        ? await ApiService.get(endpoint)
        : await ApiService.post(endpoint, body);

    let messages = [];

    if (type === "inbox") {
      messages = (res?.data || []).map(group => {
        const lastMsg = getLastMessage(group?.messages);

        return {
          Id: group.Id || group.Message_Conversation_Id,
          Title: group.Title,
          Message_Conversation_Id:
            group.Message_Conversation_Id || group.Id,
          Last_Message_Id: lastMsg?.Id,
          Message: lastMsg?.Message,
          Created_At: lastMsg?.Created_At,
          Opened_At: lastMsg?.Opened_At,
          Sender_Id: lastMsg?.Sender_Id,
          Receiver_Id: lastMsg?.Receiver_Id,
          Receiver_Type: group.Receiver_Type,
          Message_Type: group.Message_Type,
          sender: group.sender,
          receiver: group.receiver,
          _thread: group?.messages || [],
        };
      });
    }

    if (type === "sent") {
      messages = (res?.data?.data || []).map(conv => {
        const lastMsg = getLastMessage(conv?.messages);

        return {
          Conversation_Id: conv.Id,
          Receiver_Type: conv.Receiver_Type,
          Message_Type: conv.Message_Type,
          Title: conv.Title,

          Id: lastMsg?.Id,
          Message: lastMsg?.Message,
          Created_At: lastMsg?.Created_At,
          Updated_At: lastMsg?.Updated_At,
          Opened_At: lastMsg?.Opened_At,
          sender: lastMsg?.sender,
          receiver: lastMsg?.receiver,

          messages: conv.messages || [],
        };
      });
    }

    if (type === "deleted") {
      messages = (res?.data?.data || []).map(group => {
        const lastMsg = getLastMessage(group?.messages);

        return {
          Id: group.Id || group.Message_Conversation_Id,
          Title: group.Title,
          Message_Conversation_Id:
            group.Message_Conversation_Id || group.Id,
          Last_Message_Id: lastMsg?.Id,
          Message: lastMsg?.Message,
          Created_At: lastMsg?.Created_At,
          Opened_At: lastMsg?.Opened_At,
          Sender_Id: lastMsg?.Sender_Id,
          Receiver_Id: lastMsg?.Receiver_Id,
          Receiver_Type: group.Receiver_Type,
          Message_Type: group.Message_Type,
          sender: group.sender,
          receiver: group.receiver,
          messages: group?.messages || [],
        };
      });
    }

    setMessages(messages);
    setSelectedMessage(null);
    setIsNewMessage(false);

  } catch (error) {
    toast.error("Failed to load messages");
  } finally {
    setLoadingTarget(null);
    setLoading(false);
  }
};


  useEffect(() => {
    setStatusFilter("");
    setSortByDate("");
    fetchMessages(mailbox);
  }, [mailbox]);


  const handleCheck = (id) => {
    console.log(id,"-----")
    setCheckedIds((prev) =>
      prev.includes(id)
        ? prev.filter((item) => item !== id)
        : [...prev, id]
    );
  };

  useEffect(() => {
    fetchMessages(mailbox);
  }, [statusFilter, sortByDate]);

  const previewText = (text = "", chars = 200) => {
    const trimmed = text.trim();
    return trimmed.length > chars
      ? trimmed.substring(0, chars) + "..."
      : trimmed;
  };
  const receiverType =
    selectedHeader === "Stations"
      ? "Role" : selectedHeader === "Employee" ? "Individual"
        : selectedHeader
          ? selectedHeader.charAt(0).toUpperCase() +
          selectedHeader.slice(1).toLowerCase()
          : "";

  const handleSubmit = async () => {
    try {
      setLoading(true);

      if (isReply && selectedMessage) {
        // Console.log("selectedMessage======>",selectedMessage)
        const replyBody = {
          Message_Conversation_Id : selectedMessage?.Message_Conversation_Id || selectedMessage?.Id ,
          Receiver_Id: selectedMessage?.Sender_Id,
          Body: messageBody,
        };

        const resp = await ApiService.post("/message/reply", replyBody);
        // console.log("selectedMessage===>158", replyBody, resp)
        if (resp?.success) {
          toast.success(resp?.message);
        }

        // Reset
        resetCompose();
        fetchMessages(mailbox);
        return;
      }
      // Message type (Via)
      const messageTypes = [];
      if (via.push) messageTypes.push("Push");
      if (via.sms) messageTypes.push("SMS");
      if (via.email) messageTypes.push("Email");

      const body = {
        Receiver_Type: receiverType,
        Role_Type: receiverType === "Role" ? "Role" || "" : "",
        Group_Id: selectedHeader === "GROUP" ? selectedValue?.value || "" : "",
        Emp_Codes:
          selectedHeader === "Employee"
            ? selectedValue.map((item) => item.value)
            : [],
        Message_Type: messageTypes.join(","),
        Title: subject,
        Body: messageBody,
      };
      const res = await ApiService.post("/message/sendNewMessage", body);
      // console.log("messhae======>89", body, res)
      if (res?.success) {
        setSubject("");
        setMessageBody("");
        setSelectedHeader("");
        setSelectedValue("");
        setVia({ sms: false, push: true, email: false });
        setIsNewMessage(false);
        toast.success(res?.message)
      }




    } catch (error) {
      console.log("error===>", error);
      toast.error(error?.data?.message)
    } finally {
      setLoading(false);
    }
  };
  const changeDate = (date) => {
    const formatted = moment(date).format("YYYY-MM-DD");

    setSortByDate(formatted);
    fetchMessages(mailbox);
  };

  const resetCompose = () => {
    setIsNewMessage(false);
    setIsReply(false);
    setSelectedHeader("");
    setSelectedValue("");
    setSubject("");
    setMessageBody("");
  }

  const activeMenuStyle = {
    borderRadius: '4px',
    '&.Mui-selected': {
      backgroundColor: '#ffffff',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
      color: '#BF1D2D',
    },
    '&.Mui-selected:hover': {
      backgroundColor: '#ffffff',
    },
  };
  const handleSelectMessage = async (msg) => {
    // console.log("msg=====>255", msg)
    setIsNewMessage(false);
    setIsReply(false);

    setSelectedMessage(msg);
    setLoading(true);
    setLoadingTarget("detail");
    try {

      if (mailbox === "inbox") {
        await ApiService.post("/message/markAsRead", {
          msg_id: msg?.Id,
        });
        setMessages((prev) =>
          prev.map((m) =>
            m.Id === msg.Id
              ? { ...m, Opened_At: new Date().toISOString() }
              : m
          )
        );
      }
      const body = {
        status: statusFilter,
        sort_by: sortByDate,
      };
      const detailRes = await ApiService.post(`/message/${msg.Id}`, body);
      // console.log("hello=====>",msg.Id,detailRes)

      if (detailRes?.data) {
        setSelectedMessage(detailRes?.data);
      }




    } catch (error) {
      console.error("Failed to load message", error);
      toast.error(error?.data?.message);
    } finally {
      setLoading(false);
      setLoadingTarget(null);
    }
  };

  const isUnread = (msg) => !msg?.Opened_At;

const handleReply = () => {
  if (!selectedMessage) return;

  setIsReply(true);
  setIsNewMessage(true);

  // Always Employee on reply
  setSelectedHeader("Employee");

  const isAdmin = !permission.includes("Schedule_Auth");

  const replyUser = isAdmin
    ? selectedMessage?.sender
    : selectedMessage?.receiver;

  setSelectedValue([
    {
      value: replyUser?.Emp_Code,   
      desc: replyUser?.fullName, 
    },
  ]);;

  setSubject(
    selectedMessage.Title?.startsWith("Re:")
      ? selectedMessage.Title
      : `Re: ${selectedMessage.Title || ""}`
  );

  setMessageBody("");
};


  const sortedThreadMessages = React.useMemo(() => {
    if (!selectedMessage?.messages) return [];
    return [...selectedMessage.messages].sort(
      (a, b) => new Date(a.Created_At) - new Date(b.Created_At)
    );
  }, [selectedMessage]);
  const groupMessagesByDate = (messages) => {
  const groups = {};

  messages.forEach((msg) => {
    const date = moment(msg.Created_At);

    let key;
    if (date.isSame(moment(), "day")) {
      key = "Today";
    } else if (date.isSame(moment().subtract(1, "day"), "day")) {
      key = "Yesterday";
    } else {
      key = date.format("MMM D"); // Dec 2, Dec 3
    }

    if (!groups[key]) groups[key] = [];
    groups[key].push(msg);
  });

  return groups;
};
  const groupedMessages = React.useMemo(
    () => groupMessagesByDate(messages),
    [messages]
  );
const handleDeleteMessage = async () => {
  if (!selectedMessage?.Id) return;

  try {
    setLoading(true);

    const res = await ApiService.post("/message/deleteMessage", {
      msg_id: selectedMessage.Id,
    });
  //  console.log("res====>409",res)
    if (res) {
      toast.success(res.message);
      setSelectedMessage(null);
      fetchMessages(mailbox); // refresh list
    }
  } catch (error) {
    console.error("Delete failed", error);
    toast.error(error?.data?.message || "Failed to delete message");
  } finally {
    setLoading(false);
  }
};


  const CircularLoader = () => (
    <Box
      sx={{
        height: "100%",
        minHeight: 200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress
        size={32}
        thickness={4}
        sx={{ color: "#BF1D2D" }}
      />
    </Box>
  );

const handleBulkDelete = async () => {
  if (checkedIds.length === 0) return;

  try {
    setLoading(true);
    setLoadingTarget("list");

    const payload = {
      method: "Delete",
      messages: checkedIds.map((id) => ({
        msg_conv_id: id,
      })),
    };

    const res = await ApiService.post("/message/bulkAction", payload);

    if (res?.success) {
      toast.success(res.message || "Messages deleted");
      setCheckedIds([]);
      fetchMessages(mailbox);
    }
  } catch (error) {
    toast.error(error?.data?.message || "Bulk delete failed");
  } finally {
    setLoading(false);
    setLoadingTarget(null);
  }
};



  console.log("selectedValue======>153", selectedValue)
  return (
    <Box sx={{ flexGrow: 1, my: 2 }}>
      <Grid container>

        <Grid item xs={12} md={2}>
          <Box className="p-2" sx={{ height: '94vh' }}>
            {permission.includes('Schedule_Auth') && <Button
              variant="contained"
              fullWidth
              startIcon={<SendIconWhite width="16px" height="16px" />}
              className="mb-3 f-karla"
              sx={{
                backgroundColor: '#BF1D2D',
                height: '44px',
                boxShadow: 'none'
              }}
              onClick={() => {
                setIsNewMessage(true);
                 setIsReply(false);   
                setSelectedMessage(null);
                setSelectedHeader("");
                setSelectedValue([]);
              }}
            >
              New message
            </Button>}

            <List>
              <ListItem
                button
                selected={mailbox === "inbox"}
                onClick={() => setMailbox("inbox")}
                className="my-1"
                sx={activeMenuStyle}
              >
                {mailbox === "inbox"
                  ? <InboxIcon width="20px" height="20px" />
                  : <SendIconColored width="20px" height="20px" />
                }
                <ListItemText primary="Inbox" className="px-2" />
                {mailbox === "inbox" && <Chip label={messages?.length} sx={{
                  borderRadius: '6px',
                  height: 28,
                  minWidth: 28,
                  fontWeight: 600,
                  fontSize: '14px',
                }} size="small" color="error" />}
              </ListItem>

              {/* SENT */}
              <ListItem
                button
                selected={mailbox === "sent"}
                onClick={() => setMailbox("sent")}
                className="my-1"
                sx={activeMenuStyle}
              >
              { mailbox === "sent" ? <SendIcon width="20px" height="20px" /> : <SendIconBlack width="20px" height="20px" />}
                <ListItemText primary="Sent Items" className="px-2" />
                {/* <span>{mailbox === "sent" && messages?.length}</span> */}
                {mailbox === "sent" && <Chip label={messages?.length} sx={{
                  borderRadius: '6px',
                  height: 28,
                  minWidth: 28,
                  fontWeight: 600,
                  fontSize: '14px',
                }} size="small" color="error" />}
              </ListItem>

              {/* DELETED */}
              <ListItem
                button
                selected={mailbox === "deleted"}
                onClick={() => setMailbox("deleted")}
                className="my-1"
                sx={activeMenuStyle}
              >
               { mailbox === "deleted" ? <DeleteIconColored  width="20px" height="20px" /> :<DeleteIcon width="20px" height="20px" /> }
                <ListItemText primary="Deleted Items" className="px-2" />
              </ListItem>
            </List>


            <Divider className="my-3" sx={{ backgroundColor: '#99A1AF' }} />

            <Typography variant="caption" className="text-muted">
              CONFIGURATION
            </Typography>

            <List>
              <ListItem button>
                <ManageGroups width="20px" height="20px" />
                <ListItemText primary="Manage Groups" className="px-2" />
              </ListItem>
            </List>

          </Box>
        </Grid>

        {/* MESSAGE LIST */}
        <Grid item xs={12} md={3}>
          <Paper className="py-3" elevation={0} sx={{ height: '94vh', borderRadius: '0px', borderLeft: '1px solid #D1D5DC', display: 'flex', flexDirection: "column" }}>
            <Box sx={{ px: 1 }}>
               <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
              <Typography className="mb-2" sx={{ fontSize: '28px' }}>
                Inbox
              </Typography>
              {checkedIds.length > 0 && (
                    <IconButton
                      size="small"
                      sx={{
                        color: "#DC2626",
                        border: "1px solid #E5E7EB",
                        borderRadius: "6px",
                      }}
                      onClick={handleBulkDelete}
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  )}
               </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                {/* Checkbox */}
                <Checkbox
                  checked={showCheckbox}
                  onChange={(e) => setShowCheckbox(e.target.checked)}
                  sx={{ p: 0.5 }}
                />

                {/* FILTER */}
                <Box
                  className="custom-select"
                  onClick={(e) => setFilterAnchor(e.currentTarget)}
                  style={{
                    display: "flex",
                    justifyContent: "space-between"
                  }}
                >
                  <div>
                    <FilterIcon width="14px" height="14px"  marginRight="5px" />
                    <span>{filterValue}</span>
                  </div>
                  
                  <SelectIcon width="10" height="6" />
                </Box>

                <Menu
                  anchorEl={filterAnchor}
                  open={Boolean(filterAnchor)}
                  onClose={() => setFilterAnchor(null)}
                  PaperProps={{
                    sx: {
                      width: filterAnchor?.offsetWidth,
                    },
                  }}
                >
                  {["All", "Read", "Unread"].map((item) => (
                    <MenuItem
                      key={item}
                      sx={{ width: "100%" }}
                      onClick={() => {
                        setFilterValue(item);

                        const value =
                          item === "Read" ? "read" :
                            item === "Unread" ? "unread" : "";

                        setStatusFilter(value);
                        // fetchMessages(mailbox);        // 👈 hit API
                        setFilterAnchor(null);
                      }}
                    >
                      {item}
                    </MenuItem>
                  ))}
                </Menu>


                {/* SORT (DATE) */}
                <Box
                  className="custom-select"
                  onClick={(e) => setSortAnchor(e.currentTarget)}
                  style={{
                    display: "flex",
                    justifyContent: "space-between"
                  }}
                >
                  <div>
                    <span style={{ fontSize: 14, marginRight: "5px" }}>⇅</span>
                    <span>Date</span>
                  </div>
                  <SelectIcon width="10" height="6" />
                </Box>


                <Menu
                  anchorEl={sortAnchor}
                  open={Boolean(sortAnchor)}
                  onClose={() => setSortAnchor(null)}
                  PaperProps={{
                    sx: {
                      width: 320,
                      p: 1,
                    },
                  }}
                >
                  <MenuItem disableRipple sx={{ p: 0 }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <ButtonDatePickerNew
                        value={selectedDate}
                        onChange={(date) => {
                          setSelectedDate(date);
                          changeDate(date);
                          setSortAnchor(null);
                        }}
                      />
                    </LocalizationProvider>
                  </MenuItem>
                </Menu>

              </Box>
            </Box>
            <List
              className="message-list"
              sx={{ flex: 1, overflowY: "auto", px: 0 }}
            > {loading && loadingTarget === "list" ? (
              <CircularLoader />) :
              Object.keys(groupedMessages).length === 0 ? (
                <Box sx={{ textAlign: "center", mt: 4, color: "#6B7280", fontFamily: "karla", lineHeight: "21px", fontSize: "14px" }}>
                  No messages in Inbox
                </Box>
              ) :
                Object.entries(groupedMessages).map(([dateLabel, msgs]) => {
                  const isCollapsed = collapsedDates[dateLabel];

                  return (
                    <Box key={dateLabel}>
                      <Box
                        sx={{
                          px: 2,
                          py: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          bgcolor: "#FAFAFA",
                          borderBottom: "1px solid #E5E7EB",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          setCollapsedDates((prev) => ({
                            ...prev,
                            [dateLabel]: !prev[dateLabel],
                          }))
                        }
                      >
                        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                          {dateLabel}
                        </Typography>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Typography sx={{ fontSize: 12, color: "#6B7280" }}>
                            {msgs.length}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: 12,
                              transform: isCollapsed ? "rotate(-90deg)" : "rotate(0deg)",
                              transition: "0.2s",
                            }}
                          >
                            <SelectIcon width="10" height="6" />
                          </Typography>
                        </Box>
                      </Box>
                      {!isCollapsed &&
                        msgs.map((msg) => (
                          <React.Fragment key={msg.Id}>

                            <ListItem
                              button
                              className={`message-item ${selectedMessage?.Id === msg.Id ? "selected" : ""}`}
                              onClick={() => handleSelectMessage(msg)}
                              sx={{
                                alignItems: 'center',
                              }}
                            >
                              <Box className="left-border" />

                              <div style={{
                                display: "flex",
                                padding: "0 4px",
                                gap: "4px",
                                alignItems: 'center',
                                width: '100%',
                                minWidth: 0,
                              }}>

                                <div style={{ flexShrink: 0, width: '14px' }}>
                                  {showCheckbox ? (
                                    <Checkbox
                                      checked={checkedIds.includes(msg.Message_Conversation_Id || msg.Id)}
                                      onClick={(e) => e.stopPropagation()} 
                                      onChange={() =>
                                        handleCheck(msg.Message_Conversation_Id || msg.Id)
                                      }
                                      sx={{
                                        width: 12,
                                        height: 12,
                                        padding: 0,
                                        '& svg': {
                                          fontSize: 16,
                                          border: '1px solid #CCCCCC',
                                          borderRadius: '3px',
                                          boxSizing: 'border-box',
                                        },
                                        '&.Mui-checked svg': {
                                          borderColor: '#CCCCCC',
                                        },
                                    
                                      }}
                                    />
                                  ) : (
                                    isUnread(msg) && ((mailbox === "inbox") && <div className="circle" style={{ marginTop: '10px' }}></div>)
                                  )}
                                </div>
                                <div style={{
                                  flex: 1,
                                  minWidth: 0,
                                  overflow: 'hidden',
                                }}>
                                  <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: 'center',
                                    gap: "12px",
                                    marginBottom: '1px',
                                  }}>
                                    <p className="primaryTitle" style={{
                                      flex: 1,
                                      minWidth: 0,
                                      fontWeight: mailbox === "inbox" ? isUnread(msg) ?'700':'200' : '200',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      margin: 0,
                                    }}>
                                      <MailIcon width="16px" height="16px" /> {msg.sender?.fullName}
                                    </p>
                                    <Typography className="date" style={{
                                      flexShrink: 0,
                                      whiteSpace: 'nowrap',
                                    }}>
                                      {moment(msg.Created_At).format("DD MMM")}
                                    </Typography>
                                  </div>
                                  {msg?.Message_Type === "Email" && <p className="title" style={{
                                    margin: '1px 0',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    fontWeight:mailbox === "inbox" ? isUnread(msg)? '600':'200 ' : '200 !importent',
                                    whiteSpace: 'nowrap',
                                  }}>
                                    {msg?.Title}
                                  </p>}
                                  <p className="preview" style={{
                                    margin: '1px 0',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}>
                                    {previewText(msg?.Message)}
                                  </p>

                                  {/* Chips */}
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "8px",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    <Chip
                                      label={msg.Message_Type}
                                      size="small"
                                      sx={{
                                        borderRadius: "6px",
                                        height: "24px",
                                        fontSize: "13px",
                                        fontWeight: 400,
                                        bgcolor: "#EAF2FF",
                                        color: "#2563EB",
                                        border: "1px solid #D0E2FF",
                                      }}
                                    />

                                    <Chip
                                      label={msg.Receiver_Type}
                                      size="small"
                                      sx={{
                                        borderRadius: "6px",
                                        height: "24px",
                                        fontSize: "13px",
                                        fontWeight: 500,
                                        bgcolor: "#F3F4F6",
                                        color: "#374151",
                                        border: "1px solid #E5E7EB",
                                      }}
                                    />
                                  </div>

                                </div>
                              </div>
                            </ListItem>

                            <Divider />
                          </React.Fragment>
                        ))}
                    </Box>
                  );
                })}
            </List>
          </Paper>
        </Grid>

        {/* MESSAGE DETAILS */}
        <Grid item xs={12} md={7}>
          <Paper
            className="py-3 px-2"
            elevation={0}
            sx={{
              height: "94vh",
              borderRadius: "0px",
              borderLeft: "1px solid #D1D5DC",
            }}
          >
            {isNewMessage ? (<>
              <Box>
                {/* Top Bar */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
                  <Button
                    variant="contained"
                    startIcon={<SendIconWhite width="14px" height="14px" />}
                    sx={{
                      bgcolor: "#BF1D2D",
                      textTransform: "none",
                      height: 36,
                      "&:hover": { bgcolor: "#A81826" },
                    }}
                    onClick={handleSubmit}
                  >
                    Send
                  </Button>

                  <Button
                    startIcon={<AttachIcon width="16px" height="16px"/>}
                    sx={{ textTransform: "none", color: "#374151" }}
                  >
                    Attach
                  </Button>
                  

                  <Divider orientation="vertical" flexItem />

                  <DeleteMail  className="delete-icon" width="16px" height="16px" />
                </Box>

                <Divider />

                {/* TO */}
                <Box sx={{ display: "flex", alignItems: "center", py: 1 }}>
                  <Typography sx={{ width: 60 }}>To:</Typography>
                  <Select
                    size="small"
                    value={selectedHeader}
                     disabled={isReply}
                    // IconComponent={SelectIcon}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSelectedHeader(value);
                      setSelectedValue(value === "Employee" ? [] : '');
                    }}

                    displayEmpty
                    sx={{ mr: 1, width: 140 }}
                    renderValue={(selected) =>
                      selected === '' ? (
                        <span style={{ color: '#9CA3AF' }}>Select role</span>
                      ) : (
                        selected
                      )
                    }
                  >
                    <MenuItem value="" disabled>
                      Select role
                    </MenuItem>

                    {headers?.map((item, index) => (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>

                  <Select
                    size="small"
                    multiple={selectedHeader === "Employee"}
                    value={
                      selectedHeader === "Employee"
                        ? Array.isArray(selectedValue)
                          ? selectedValue.map(v => v.value)
                          : []
                        : selectedValue?.value || ''
                    }
                    // IconComponent={SelectIcon}

                    displayEmpty
                    sx={{ flex: 1 }}
                    disabled={!selectedHeader || isReply}
                    // onChange={(e) => {
                    //   const values = e.target.value;

                    //   const selectedEmployees = sendTo["Employee"]
                    //     .filter(emp => values.includes(emp.value));

                    //   setSelectedValue(selectedEmployees);
                    // }}
                    onChange={(e) => {
                      const value = e.target.value;

                      // Employee → multi select
                      if (selectedHeader === "Employee") {
                        const selectedEmployees = sendTo["Employee"]
                          .filter(emp => value.includes(emp.value));

                        setSelectedValue(selectedEmployees);
                      }
                      // Station / Group / others → single select
                      else {
                        const selectedItem =
                          sendTo[selectedHeader]?.find(item => item.value === value);

                        setSelectedValue(selectedItem || '');
                      }
                    }}

                    renderValue={(selected) => {
                      // Placeholder
                      if (
                        selected === '' ||
                        (Array.isArray(selected) && selected.length === 0)
                      ) {
                        return <span style={{ color: '#9CA3AF' }}>Select value</span>;
                      }

                      // Employee → multi
                      // if (Array.isArray(selected)) {
                      //   return selected
                      //     .map((item) => item.desc || item.value || item)
                      //     .join(', ');
                      // }
                      // Employee → multi (FIXED UI)
                      if (Array.isArray(selected)) {
                        return (
                          <Box
                            sx={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: 0.5,
                              maxHeight: 72,
                              overflowY: 'auto',
                            }}
                          >
                            {selected.map((empCode, index) => {
                              const emp =
                                selectedValue.find(v => v.value === empCode) ||
                                sendTo["Employee"]?.find(e => e.value === empCode);

                              return (
                                <Chip
                                  key={index}
                                  label={emp?.desc || "Unknown"}
                                  size="small"
                                  onMouseDown={(e) => {
                                    e.stopPropagation();
                                  }}
                                  onDelete={(e) => {
                                    e.stopPropagation();
                                    setSelectedValue(prev =>
                                      prev.filter(e => e.value !== empCode)
                                    );
                                  }}
                                />
                              );
                            })}

                          </Box>
                        );
                      }

                      // Others → single
                      return selected.desc || selected.value || selected;
                    }}
                  >
                    <MenuItem value="" disabled>
                      Select value
                    </MenuItem>

                    {(sendTo[selectedHeader] || []).length === 0 ? (
                      <MenuItem disabled>No data available</MenuItem>
                    ) : (
                      sendTo[selectedHeader]?.map((item, index) => (
                        <MenuItem key={index} value={item.value}>
                          {item.desc}
                        </MenuItem>

                      ))
                    )}
                  </Select>


                </Box>
                {!isReply && (<>
                  <Divider />
                  <Box sx={{ display: "flex", alignItems: "center", py: 1 }}>
                    <Typography sx={{ width: 60 }}>Via:</Typography>

                    <Checkbox
                      size="small"
                      checked={via.sms}
                      onChange={(e) =>
                        setVia((prev) => ({ ...prev, sms: e.target.checked }))
                      }
                    />
                    SMS

                    <Checkbox
                      size="small"
                      sx={{ ml: 2 }}
                      checked={via.push}
                      onChange={(e) =>
                        setVia((prev) => ({ ...prev, push: e.target.checked }))
                      }
                    />
                    Push Notification

                    <Checkbox
                      size="small"
                      sx={{ ml: 2 }}
                      checked={via.email}
                      onChange={(e) =>
                        setVia((prev) => ({ ...prev, email: e.target.checked }))
                      }
                    />
                    Email
                  </Box>

                </>)}
                <Divider />
                {via?.email && <Box sx={{ py: 1, display: 'flex', alignItems: 'center', gap: '8px' }} >
                  <Typography color="#6B7280" sx={{ mb: 0.5 }}>
                    Subject:
                  </Typography>

                  <TextField
                    fullWidth
                    variant="standard"
                    placeholder="Add a subject"
                    disabled={!via?.email}
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    sx={{
                      fontSize: "14px",
                      '& input::placeholder': {
                        color: '#9CA3AF',
                        opacity: 1,
                      },
                    }}
                  />
                </Box>}
                <Divider />
                <Box sx={{ py: 2 }}>
                  <TextField
                    fullWidth
                    multiline
                    minRows={6}
                    variant="standard"
                    placeholder="Type your message here..."
                    value={messageBody}
                    onChange={(e) => setMessageBody(e.target.value)}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    sx={{
                      fontSize: "14px",
                      '& textarea::placeholder': {
                        color: '#9CA3AF',
                        opacity: 1,
                      },
                    }}
                  />
                </Box>
              </Box>
            </>) : loading && loadingTarget === "detail" ? (
              <CircularLoader />)
              : !selectedMessage ? (
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  {/* Icon Circle */}
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: "50%",
                      backgroundColor: "#F3D6D6",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2,
                    }}
                  >
                    <NoMailIcon width="28px" height="28px" />
                  </Box>

                  {/* Title */}
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: 600,
                      // color: "#111827",
                      mb: 1,
                    }}
                  >
                    No message selected
                  </Typography>

                  {/* Subtitle */}
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#6B7280",
                      textAlign: "center",
                      // maxWidth: "320px",
                      lineHeight: "20px",
                    }}
                  >
                    Select a message from the list to view its contents, or
                    <br />
                    click "New message" to start a new communication.
                  </Typography>
                </Box>

              ) : (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 2,
                      color: "#374151",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}>
                      <ReplyMail width="18px" height="18px" />
                      <Typography fontSize="14px" onClick={handleReply} >Reply</Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        cursor: "pointer",
                        color: "#DC2626",
                      }}
                        onClick={handleDeleteMessage}
                    >
                      <DeleteMail width="18px" height="18px" />
                      <Typography fontSize="14px">Delete</Typography>
                    </Box>
                  </Box>
                  <Divider sx={{ mb: 1, borderColor: "#E5E7EB" }} />
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mb: 1.5,
                    }}
                  >
                    {/* Left side */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <Typography
                        sx={{
                          fontSize: "18px",
                          fontWeight: 600,
                          // color: "#111827",
                        }}
                      >
                        {selectedMessage.Title}
                      </Typography>

                      <Chip
                        label={selectedMessage?.Message_Type}
                        size="small"
                        sx={{
                          bgcolor: "#E5F0FF",
                          color: "#2563EB",
                          fontSize: "12px",
                          fontWeight: 500,
                        }}
                      />

                      <Chip
                        label={selectedMessage?.Receiver_Type}
                        size="small"
                        sx={{
                          bgcolor: "#F3F4F6",
                          color: "#374151",
                          fontSize: "12px",
                          fontWeight: 500,
                        }}
                      />
                    </Box>

                    {/* Date */}
                    <Typography sx={{ fontSize: "13px", color: "#6B7280" }}>
                      {moment(selectedMessage?.Updated_At, "YYYY-MM-DD HH:mm:ss").format("MMM D [at] h:mm A")}
                    </Typography>
                  </Box>
                  <Box>
                    <Box sx={{ display: "flex", mb: 0.5 }}>
                      <Typography sx={{ fontSize: "14px", color: "#6B7280", width: "50px" }}>
                        From
                      </Typography>
                      <Typography sx={{ fontSize: "14px", color: "#111827", fontWeight: 500 }}>
                        {selectedMessage?.sender?.fullName}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex" }}>
                      <Typography sx={{ fontSize: "14px", color: "#6B7280", width: "50px" }}>
                        To
                      </Typography>
                      <Typography sx={{ fontSize: "14px", color: "#111827", fontWeight: 500 }}>
                        {selectedMessage?.receiver?.fullName}
                      </Typography>
                    </Box>
                  </Box>


                  <Divider sx={{ mb: 1, borderColor: "#E5E7EB" }} />
                     
                      <Box
                        sx={{
                          flex: 1,
                          overflowY: "auto",
                          px: 0,
                          py: 0,
                          maxHeight: "calc(100vh - 300px)",
                          '&::-webkit-scrollbar': {
                            width: '6px',
                          },
                          '&::-webkit-scrollbar-thumb': {
                            backgroundColor: '#D1D5DC',
                            borderRadius: '3px',
                          },
                          '&::-webkit-scrollbar-track': {
                            backgroundColor: '#F3F4F6',
                          },
                        }}
                      >
                        {sortedThreadMessages.map((m, index) => {
                          const isMe = m.Sender_Id === selectedMessage?.receiver?.Emp_Code;
                          const isFirstMessage = index === 0;

                          return (
                            <Box
                              key={index}
                              sx={{
                                borderBottom: '1px solid #E5E7EB',
                                px: 3,
                                py: 2.5,
                                bgcolor: '#FFFFFF',
                                '&:hover': {
                                  bgcolor: '#F9FAFB',
                                },
                              }}
                            >
                              {/* Header - Name, Email, Time, Actions */}
                              <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                                {/* Avatar */}
                                <Box
                                  sx={{
                                    width: 30,
                                    height: 30,
                                    borderRadius: '50%',
                                    bgcolor: isMe ? '#8B5CF6' : '#10B981',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: 16,
                                    fontWeight: 400,
                                    color: '#FFFFFF',
                                    flexShrink: 0,
                                    mr: 2,
                                  }}
                                >
                                  {m.sender?.fullName?.charAt(0) || "U"}
                                </Box>

                                {/* Name, Email, Time */}
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>
                                      {m.sender?.fullName || "Unknown"}
                                    </Typography>
                                    {/* <Typography sx={{ fontSize: 13, color: '#6B7280' }}>
                                      {`<${m.sender?.email || 'unknown@email.com'}>`}
                                    </Typography> */}
                                  </Box>

                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                                    <Typography sx={{ fontSize: 12, color: '#6B7280' }}>
                                      to {isMe ? m.receiver?.fullName : 'me'}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontSize: 12,
                                        color: '#9CA3AF',
                                        cursor: 'pointer',
                                        transform: collapsedMap[m.Id] ? 'rotate(-90deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.2s ease',
                                      }}
                                      onClick={() =>
                                        setCollapsedMap(prev => ({
                                          ...prev,
                                          [m.Id]: !prev[m.Id], // toggle only this message
                                        }))
                                      }
                                    >
                                      ▼
                                    </Typography>
                                  </Box>
                                </Box>

                                {/* Time & Actions */}
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                  <Typography sx={{ fontSize: 13, color: '#6B7280' }}>
                                    {moment(m.Created_At).format('h:mm A (D MMMM YYYY)')}
                                  </Typography>
                                  <Box sx={{ display: 'flex', gap: 1 }}>
                                    <IconButton size="small" sx={{ color: '#6B7280' }}>
                                      <StarIcon sx={{ fontSize: 20, color: "#FACC15" }} />
                                    </IconButton>
                                    <IconButton size="small" sx={{ color: '#6B7280' }}>
                                      {/* <ReplyIcon sx={{ fontSize: 20 }} /> */}
                                      <ReplyMail width="14px" height="14px" />
                                    </IconButton>
                                    <IconButton size="small" sx={{ color: '#6B7280' }}>
                                      <MoreVertIcon sx={{ fontSize: 20 }} />
                                    </IconButton>
                                  </Box>
                                </Box>
                              </Box>

                              {/* Message Content */}
                          {!collapsedMap[m.Id] && (    <Box sx={{ pl: 7 }}>
                                {/* Show quoted message if not first */}
                                {!isFirstMessage && index > 0 && (
                                  <Box
                                    sx={{
                                      pl: 2,
                                      borderLeft: '3px solid #E5E7EB',
                                      mb: 2,
                                      color: '#6B7280',
                                      fontSize: 13,
                                    }}
                                  >
                                    <Typography sx={{ fontSize: 12, color: '#9CA3AF', mb: 0.5 }}>
                                      On {moment(sortedThreadMessages[index - 1].Created_At).format('ddd, MMM D, YYYY [at] h:mm A')} {sortedThreadMessages[index - 1].sender?.fullName} {`<${sortedThreadMessages[index - 1].sender?.email || ''}>`} wrote:
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontSize: 13,
                                        color: '#6B7280',
                                        whiteSpace: 'pre-line',
                                        lineHeight: 1.5,
                                      }}
                                    >
                                      {sortedThreadMessages[index - 1].Message}
                                    </Typography>
                                  </Box>
                                )}

                                {/* Current Message */}
                                <Typography
                                  sx={{
                                    fontSize: 14,
                                    color: '#111827',
                                    whiteSpace: 'pre-line',
                                    lineHeight: 1.6,
                                  }}
                                >
                                  {m.Message}
                                </Typography>

                                {/* Show "..." for collapsed thread indicator (optional) */}
                                {index === sortedThreadMessages.length - 1 && sortedThreadMessages.length > 1 && (
                                  <Box
                                    sx={{
                                      mt: 2,
                                      pt: 1,
                                      borderTop: '1px solid #E5E7EB',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 1,
                                    }}
                                  >
                                    <Typography sx={{ fontSize: 24, color: '#9CA3AF', fontWeight: 300 }}>
                                      •••
                                    </Typography>
                                  </Box>
                                )}
                              </Box>)}
                            </Box>
                          );
                        })}
                      </Box>
                </>

              )}
          </Paper>
        </Grid>


      </Grid>
    </Box>
  )
}
